import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDataTransferHorizontalIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Link } from "react-router-dom";
import { cx } from "shared/utils";
import { formatCalendar } from "../helpers/format-calendar";
import { useMarkNotificationAsRead } from "../helpers/call-notification";
import { Notification } from "../types";

const FALLBACK_TITLE = "Bring your number";

// Fallback for `url: null`; keep in sync with the backend Notification#url.
const portRequestUrl = (metadata: Notification["metadata"]) =>
  metadata.port_request_id
    ? `/phone-numbers?port_request=${metadata.port_request_id}`
    : "/phone-numbers";

// CRM-1769: a number being moved into Boom changed stage (date set, rejected,
// live, canceled or expired). Opens that request on the Phone numbers screen.
export const PhoneNumberPortNotificationCard = ({
  item
}: {
  item: Notification;
}) => {
  const { id, read_at, url, metadata, created_at } = item;
  const markAsRead = useMarkNotificationAsRead();

  return (
    <Link
      to={url || portRequestUrl(metadata)}
      onClick={() => {
        if (!read_at) markAsRead([id]);
      }}
      className="flex flex-col gap-3 bg-white p-6 hover:bg-alpha-40"
    >
      <div className="flex items-center justify-between gap-4">
        <p className="flex min-w-0 items-center gap-2 text-sm font-medium text-content-300">
          <HugeiconsIcon
            icon={ArrowDataTransferHorizontalIcon}
            size={16}
            className="shrink-0 text-primary-500"
            aria-hidden
          />
          <span className="truncate">Phone numbers</span>
        </p>
        <p className="shrink-0 text-sm font-medium text-content-300">
          {formatCalendar(created_at)}
        </p>
      </div>

      <div className="flex min-w-0 items-center gap-4">
        <span
          className={cx(
            "size-3 shrink-0 rounded-full",
            read_at ? "bg-alpha-40" : "bg-primary-500"
          )}
        />
        <div className="min-w-0">
          <p className="break-words text-base font-bold text-content-1000">
            {metadata.title || FALLBACK_TITLE}
          </p>
          {metadata.body ? (
            <p className="break-words text-base font-medium text-content-400">
              {metadata.body}
            </p>
          ) : null}
        </div>
      </div>
    </Link>
  );
};
